import React, { useState, useEffect } from "react";
import CopyableField from './CopyableField';
import axios from "axios";
import CopyToAccountWizard from "./CopyToAccountWizard";

const API = "/api";

export default function CompareAccounts({ currentUser }: any) {
  const [accounts, setAccounts] = useState<any[]>([]);
  const [crossAccounts, setCrossAccounts] = useState<any[]>([]);
  const [acc1, setAcc1] = useState("");
  const [acc2, setAcc2] = useState("");
  const [items, setItems] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [msg, setMsg] = useState("");
  const [selected, setSelected] = useState<Set<string>>(new Set());
  const [showCopyWizard, setShowCopyWizard] = useState(false);
  const [names, setNames] = useState<{a1: string, a2: string}>({a1: "", a2: ""});

  useEffect(() => {
    axios.get(API + "/allegro/accounts").then(r => setAccounts(r.data || [])).catch(() => {});
    axios.get(API + "/offers/cross-accounts").then(r => setCrossAccounts(r.data?.accounts || [])).catch(() => {});
  }, []);

  const allAccounts = [...accounts, ...crossAccounts];

  const doCompare = async () => {
    if (!acc1 || !acc2) { setMsg("Wybierz oba konta"); return; }
    if (acc1 === acc2) { setMsg("Wybierz dwa rozne konta"); return; }
    setLoading(true); setMsg(""); setDone(false); setSelected(new Set());
    try {
      const r = await axios.get(API + "/offers/compare-accounts", { params: { account1_id: acc1, account2_id: acc2 } });
      setItems(r.data.items || []);
      setNames({a1: r.data.account1_name || "", a2: r.data.account2_name || ""});
      setDone(true);
    } catch (e: any) {
      setMsg(e?.response?.data?.detail || "Blad porownania");
    } finally { setLoading(false); }
  };

  const toggleSelect = (id: string) => {
    const s = new Set(selected);
    if (s.has(id)) s.delete(id); else s.add(id);
    setSelected(s);
  };
  const selectAll = () => {
    if (selected.size === items.length) setSelected(new Set());
    else setSelected(new Set(items.map(o => o.id)));
  };

  const s: any = {
    input: { padding: "8px 10px", borderRadius: 8, border: "1px solid #d1d5db", fontSize: 13, background: "#fff" },
    btn: { padding: "8px 16px", borderRadius: 8, border: "none", cursor: "pointer", fontSize: 13, fontWeight: 600 },
  };

  return (
    <div style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: 12, padding: 20 }}>
      <h3 style={{ marginTop: 0, fontSize: 16 }}>🔀 Porównanie kont</h3>
      <p style={{ fontSize: 13, color: "#555", marginTop: 4 }}>
        Wybierz dwa konta. Pokażemy oferty z konta 1, których (wg EAN) brak na koncie 2 — możesz je skopiować (wystawić) na konto 2.
      </p>

      <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap", marginBottom: 12 }}>
        <select value={acc1} onChange={e => setAcc1(e.target.value)} style={{ ...s.input, minWidth: 200 }}>
          <option value="">— Konto 1 (źródło) —</option>
          {accounts.map((a: any) => <option key={a.id} value={a.id}>{a.name}</option>)}
          {crossAccounts.map((a: any) => <option key={a.id} value={a.id}>↗ {a.name} (obce)</option>)}
        </select>
        <span style={{ color: "#9ca3af", fontWeight: 700 }}>→</span>
        <select value={acc2} onChange={e => setAcc2(e.target.value)} style={{ ...s.input, minWidth: 200 }}>
          <option value="">— Konto 2 (cel) —</option>
          {accounts.map((a: any) => <option key={a.id} value={a.id}>{a.name}</option>)}
          {crossAccounts.map((a: any) => <option key={a.id} value={a.id}>↗ {a.name} (obce)</option>)}
        </select>
        <button onClick={doCompare} disabled={loading} style={{ ...s.btn, background: "#0891b2", color: "#fff", opacity: loading ? 0.6 : 1 }}>
          {loading ? "Porównuję…" : "Porównaj"}
        </button>
      </div>

      {msg && <div style={{ color: "#dc2626", fontSize: 13, marginBottom: 10 }}>{msg}</div>}

      {done && (
        <div>
          <div style={{ fontSize: 13, marginBottom: 8, color: "#374151" }}>
            <b>{names.a1}</b> → <b>{names.a2}</b>: znaleziono <b>{items.length}</b> ofert brakujących na koncie 2.
            {selected.size > 0 && (
              <button onClick={() => setShowCopyWizard(true)} style={{ ...s.btn, background: "#7c3aed", color: "#fff", marginLeft: 12 }}>
                📋 Kopiuj zaznaczone ({selected.size}) na konto 2
              </button>
            )}
          </div>

          {items.length === 0 ? (
            <div style={{ padding: 30, textAlign: "center", color: "#9ca3af" }}>Wszystkie oferty konta 1 są już na koncie 2 (lub brak ofert z EAN).</div>
          ) : (
            <div style={{ border: "1px solid #e5e7eb", borderRadius: 8, overflow: "hidden" }}>
              <div style={{ display: "grid", gridTemplateColumns: "36px 56px 1fr 90px 85px 65px 130px 90px", gap: 8, padding: "8px 12px", background: "#f9fafb", borderBottom: "1px solid #e5e7eb", fontSize: 11, fontWeight: 600, color: "#6b7280", alignItems: "center" }}>
                <div><input type="checkbox" checked={selected.size === items.length && items.length > 0} onChange={selectAll} /></div>
                <div>FOTO</div>
                <div>NAZWA/SKU</div>
                <div>CENA</div>
                <div>STAN</div>
                <div>SPRZED.</div>
                <div>KONTO</div>
                <div>LINK</div>
              </div>
              {items.map(o => (
                <div key={o.id} style={{ display: "grid", gridTemplateColumns: "36px 56px 1fr 90px 85px 65px 130px 90px", gap: 8, padding: "8px 12px", borderBottom: "1px solid #f3f4f6", alignItems: "center", background: "#fff", fontSize: 12 }}>
                  <div><input type="checkbox" checked={selected.has(o.id)} onChange={() => toggleSelect(o.id)} /></div>
                  <div>{o.image_url ? <img src={o.image_url} alt="" style={{ width: 46, height: 46, objectFit: "cover", borderRadius: 4, border: "1px solid #e5e7eb" }} /> : <div style={{ width: 46, height: 46, background: "#f3f4f6", borderRadius: 4 }} />}</div>
                  <div>
                    <div style={{ fontWeight: 500, color: "#111827", marginBottom: 1 }}>{o.name}</div>
                    <div style={{ color: "#6b7280", fontSize: 11 }}>{o.sku && <CopyableField label="SKU" value={o.sku} />}{o.ean && o.ean !== "N/A" && <CopyableField label="EAN" value={o.ean} />}<CopyableField label="nr" value={o.offer_id} muted /></div>
                  </div>
                  <div style={{ fontWeight: 700 }}>{o.price?.toFixed(2)} {o.currency}</div>
                  <div>{o.stock_available} szt.</div>
                  <div>{o.stock_sold || 0}</div>
                  <div style={{ color: "#9ca3af", fontSize: 11 }}>{o.account_name}</div>
                  <div><a href={o.offer_url} target="_blank" rel="noreferrer" style={{ fontSize: 11, color: "#1d4ed8" }}>Link</a></div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {showCopyWizard && (() => {
        // konto 2: wlasne (jest w accounts) -> preselekcja po id; obce (crossAccounts) -> po nazwie
        const _own2 = accounts.find((a: any) => a.id === acc2);
        const _cross2 = crossAccounts.find((a: any) => a.id === acc2);
        return (
          <CopyToAccountWizard
            offerIds={Array.from(selected)}
            accounts={allAccounts}
            currentUser={currentUser}
            preselectedTargetId={_own2 ? acc2 : undefined}
            preselectedOtherName={!_own2 && _cross2 ? _cross2.name : undefined}
            onClose={() => { setShowCopyWizard(false); doCompare(); }}
            onDone={() => { setSelected(new Set()); doCompare(); }}
          />
        );
      })()}
    </div>
  );
}
